(() => {
  const summaryLayouts = new Map();
  const desktop = window.matchMedia('((min-width: 750px) or ((min-width: 640px) and (min-height: 520px) and (any-pointer: coarse)))');
  const restoreSummary = (state) => {
    if (state.origin.nextSibling !== state.summary) state.origin.after(state.summary);
  };

  const disposeSummary = (root, state) => {
    if (state.frame) cancelAnimationFrame(state.frame);
    state.observer?.disconnect();
    state.media.removeEventListener('load', state.schedule, true);
    if (state.origin.isConnected && state.summary.isConnected) restoreSummary(state);
    state.origin.remove();
    summaryLayouts.delete(root);
  };

  const arrangeSummary = (root, state) => {
    state.frame = 0;
    if (!root.isConnected || !state.origin.isConnected || !root.contains(state.summary)) {
      disposeSummary(root, state);
      return;
    }
    restoreSummary(state);
    if (root.dataset.lchSummaryPlacement !== 'info') root.dataset.lchSummaryPlacement = 'info';
    const hasDescription = [...state.info.querySelectorAll('.lch-product-details, .lch-shopify-description, .lch-coral-story')]
      .some((description) => description.textContent.trim().length > 0);
    if (!desktop.matches || !hasDescription || state.product.classList.contains('product--no-media')) return;
    if (state.media.getBoundingClientRect().height <= 0) return;
    const originalHeight = state.product.getBoundingClientRect().height;
    state.media.append(state.summary);
    const mediaHeight = state.product.getBoundingClientRect().height;
    if (originalHeight - mediaHeight >= 12) {
      root.dataset.lchSummaryPlacement = 'media';
    } else {
      restoreSummary(state);
    }
  };

  const initializeSummaries = () => {
    summaryLayouts.forEach((state, root) => {
      if (!root.isConnected) disposeSummary(root, state);
    });
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach((root) => {
      const current = summaryLayouts.get(root);
      if (current) {
        current.schedule();
        return;
      }
      const product = root.querySelector('.page-width > .product');
      const media = product?.querySelector(':scope > .product__media-wrapper');
      const info = product?.querySelector(':scope > .product__info-wrapper');
      const summary = info?.querySelector('.lch-coral-description > .lch-coral-summary');
      if (!product || !media || !info || !summary) return;
      const origin = document.createElement('span');
      origin.hidden = true;
      origin.className = 'lch-summary-origin';
      summary.before(origin);
      const state = { product, media, info, summary, origin, frame: 0, observer: null, schedule: null };
      state.schedule = () => {
        if (!state.frame) state.frame = requestAnimationFrame(() => arrangeSummary(root, state));
      };
      if (typeof ResizeObserver !== 'undefined') {
        state.observer = new ResizeObserver(state.schedule);
        state.observer.observe(media);
        state.observer.observe(info);
      }
      media.addEventListener('load', state.schedule, true);
      summaryLayouts.set(root, state);
      state.schedule();
    });
  };

  const arrangeRecommendations = () => {
    const main = document.getElementById('MainContent');
    const productSection = main?.querySelector('product-info[id^="MainProduct-"]')?.closest('.shopify-section');
    if (!main || !productSection) return;
    const recommendation = main.querySelector('product-recommendations.related-products')?.closest('.shopify-section');
    if (!recommendation || recommendation.parentElement !== productSection.parentElement) return;
    if (productSection.nextElementSibling !== recommendation) productSection.after(recommendation);
  };

  const initialize = () => {
    initializeSummaries();
    arrangeRecommendations();
  };
  const scheduleSummaries = () => summaryLayouts.forEach((state) => state.schedule());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => {
    summaryLayouts.forEach((state, root) => {
      if (!root.isConnected) disposeSummary(root, state);
    });
  });
  document.addEventListener('product-info:loaded', initialize);
  window.addEventListener('resize', scheduleSummaries);
  window.addEventListener('load', scheduleSummaries, { once: true });
  document.fonts?.ready.then(scheduleSummaries);
})();
